import { render, staticRenderFns } from "./kanbantour.vue?vue&type=template&id=2644f7f4"
import script from "./kanbantour.vue?vue&type=script&lang=js"
export * from "./kanbantour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports